import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class RecordingYear extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "rec";
    }
}

export function RecordingYear$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.RecordingYear", void 0, RecordingYear, Metadata_NumberCategory$reflection());
}

export function RecordingYear_$ctor_Z721C83C5(aName) {
    return new RecordingYear(aName);
}

export class BirthYear extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "birth";
    }
}

export function BirthYear$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.BirthYear", void 0, BirthYear, Metadata_NumberCategory$reflection());
}

export function BirthYear_$ctor_Z721C83C5(aName) {
    return new BirthYear(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Age extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "age";
    }
}

export function Age$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.Age", void 0, Age, Metadata_NumberCategory$reflection());
}

export function Age_$ctor_Z721C83C5(aName) {
    return new Age(aName);
}

export class AgeGroup extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "agegroup";
    }
}

export function AgeGroup$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.AgeGroup", void 0, AgeGroup, Metadata_StringCategory$reflection());
}

export function AgeGroup_$ctor_Z721C83C5(aName) {
    return new AgeGroup(aName);
}

export class DistrictCode extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "district_code";
    }
}

export function DistrictCode$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.DistrictCode", void 0, DistrictCode, Metadata_StringCategory$reflection());
}

export function DistrictCode_$ctor_Z721C83C5(aName) {
    return new DistrictCode(aName);
}

export class Place extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "place";
    }
}

export function Place$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.Place", void 0, Place, Metadata_StringCategory$reflection());
}

export function Place_$ctor_Z721C83C5(aName) {
    return new Place(aName);
}

export class Area extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "area";
    }
}

export function Area$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.Area", void 0, Area, Metadata_StringCategory$reflection());
}

export function Area_$ctor_Z721C83C5(aName) {
    return new Area(aName);
}

export class Region extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "region";
    }
}

export function Region$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.Region", void 0, Region, Metadata_StringCategory$reflection());
}

export function Region_$ctor_Z721C83C5(aName) {
    return new Region(aName);
}

export class Country extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "country";
    }
}

export function Country$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.Country", void 0, Country, Metadata_StringCategory$reflection());
}

export function Country_$ctor_Z721C83C5(aName) {
    return new Country(aName);
}

export class Notes extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "notes";
    }
}

export function Notes$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.Notes", void 0, Notes, Metadata_StringCategory$reflection());
}

export function Notes_$ctor_Z721C83C5(aName) {
    return new Notes(aName);
}

export class Taxonomy extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "taxonomy";
    }
}

export function Taxonomy$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.Taxonomy", void 0, Taxonomy, Metadata_StringCategory$reflection());
}

export function Taxonomy_$ctor_Z721C83C5(aName) {
    return new Taxonomy(aName);
}

export class Genre extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "genre";
    }
}

export function Genre$reflection() {
    return class_type("Corpora.Ndc2.MetadataCategories.Genre", void 0, Genre, Metadata_StringCategory$reflection());
}

export function Genre_$ctor_Z721C83C5(aName) {
    return new Genre(aName);
}

